export default __webpack_public_path__ + "static/how-it-works-1-312ab53557eab82dc481107ecb51b1f2.png";